import axiosInstance from '@/lib/axios';

export type AppErrorReportPayload = {
  message: string;
  stack?: string;
  componentStack?: string;
  sourceFile?: string;
  sourceLine?: string;
  sourceColumn?: string;
  url: string;
  userAgent: string;
  occurredAt: string;
};

const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) return error.message;
  if (typeof error === 'string') return error;
  return 'Unknown application error';
};

const getErrorStack = (error: unknown): string | undefined => {
  if (error instanceof Error) return error.stack;
  return undefined;
};

const parseSourceLocation = (stack?: string) => {
  if (!stack) return {};

  const lines = stack
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);

  const frame =
    lines.find((line) => /https?:\/\/|\/assets\/|\.tsx?:\d+:\d+|\.js:\d+:\d+/.test(line)) ||
    lines[0];

  if (!frame) return {};

  const match = frame.match(/(?:\()?(.*?):(\d+):(\d+)\)?$/);
  if (!match) return { sourceFile: frame };

  return {
    sourceFile: match[1],
    sourceLine: match[2],
    sourceColumn: match[3],
  };
};

export const buildAppErrorReportPayload = (
  error: unknown,
  componentStack?: string
): AppErrorReportPayload => {
  const stack = getErrorStack(error);
  return {
    message: getErrorMessage(error),
    stack,
    componentStack,
    ...parseSourceLocation(stack),
    url: window.location.href,
    userAgent: window.navigator.userAgent,
    occurredAt: new Date().toISOString(),
  };
};

export const reportAppError = async (payload: AppErrorReportPayload) => {
  const response = await axiosInstance.post('/error-reports', payload);
  return response.data;
};
